import { render, staticRenderFns } from "./AwardRankingListSection.vue?vue&type=template&id=17496995&scoped=true"
import script from "./AwardRankingListSection.vue?vue&type=script&lang=ts"
export * from "./AwardRankingListSection.vue?vue&type=script&lang=ts"
import style0 from "./AwardRankingListSection.vue?vue&type=style&index=0&id=17496995&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17496995",
  null
  
)

export default component.exports